module.exports = __webpack_public_path__ + "img/blue-circle-table-1.71bf764d.png";